import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.CONFIRM_BOOKING_PENDING: {
      return {
        ...state,
        pending: true,
        error: '',
        success: false,
      };
    }

    case type.CONFIRM_BOOKING_SUCCESS: {
      return {
        ...state,
        pending: false,
        success: true,
      };
    }

    case type.CONFIRM_BOOKING_FAILURE: {
      return {
        ...state,
        pending: false,
        success: false,
        error: action.payload,
      };
    }

    case type.CLEAR_CONFIRM_BOOKING:
      return {
        ...state,
        data: [],
        pending: false,
        success: false,
        error: '',
      };

    default:
      return state;
  }
};
